import { takeLatest, put } from 'redux-saga/effects';
import { createAxios, getParamString, logNative } from '../utils/utils';
import {
  GET_SOFT_INFOS_55,
  // BANNER_CONTENT_53,
  BANNER_CONTENT_61,
  RANK_MIX_RANK_53,
  RECOMMEND_CONTENT_53,
  GROUNP_CONTENT_53,
  // GUESS_LIKES_URL,
  GUESS_LIKES_NEW_61,
  RECO_TOP_CONTENTS_66,
  RECO_RECOMMEND_CONTENTS_66,
} from '../config';
import {
  RECOMMEND_BANNER_REQUEST,
  RECOMMEND_BANNER_SUCCESS,
  RECOMMEND_WEEK_HOTS_REQUEST,
  RECOMMEND_WEEK_HOTS_SUCCESS,
  RECOMMEND_RECOMMEND_REQUEST,
  RECOMMEND_RECOMMEND_SUCCESS,
  RECOMMEND_GROUP_REQUEST,
  RECOMMEND_GROUP_SUCCESS,
  GUESS_LIKES_REQUEST,
  GUESS_LIKES_SUCCESS,
  GET_SOFTINFOS_REQUEST,
  GET_SOFTINFOS_SUCCESS,
  RECO_TOP_CONTENTS_REQUEST,
  RECO_TOP_CONTENTS_SUCCESS,
  RECOWORK_TOP_CONTENTS_SUCCESS,
  RECOOTHER_TOP_CONTENTS_SUCCESS,
  RECO_RECOMMEND_CONTENTS_REQUEST,
  RECO_RECOMMEND_CONTENTS_SUCCESS,
  RECOWORK_RECOMMEND_CONTENTS_SUCCESS,
  RECOOTHER_RECOMMEND_CONTENTS_SUCCESS,
  RECOMMEND_OTHER_TOP_REQUEST,
  RECOMMEND_OTHER_TOP_SUCCESS,
  GET_SOFTINFOS_BY_V_REQUEST,
  GET_SOFTINFOS_BY_V_SUCCESS,
} from '../constants/recommend';

/**
 * 其他推荐group
 */
function* fetchGroupContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GROUNP_CONTENT_53, {
      params: { pageType: param.pageType || 'soft' },
    });

    if (res.data && res.data.status === 0) {
      yield put({
        type: RECOMMEND_GROUP_SUCCESS,
        payload: {
          dataList: [...res.data.data],
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 其他推荐 top 8.2新增
 */
function* fetchRecoOtherTop(param) {
  yield put({ type: RECOMMEND_OTHER_TOP_SUCCESS, payload: {} });
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RECO_RECOMMEND_CONTENTS_66, {
      params: { pageType: param.pageType || 'upgradeTop', time: +new Date() },
    });
    if (res.data.status === 0) {
      let type = '';
      if (param.pageType === 'upgradeTop') {
        type = RECOMMEND_OTHER_TOP_SUCCESS;
        yield put({ type, payload: { ...res.data, ...param } });
      }
    }
  } catch (error) {
    // throw error;
  }
}
/**
 * 首页改版后获取group 2021-1-19 21:43:00
 */
function* fetchRecoRecommend(param) {
  yield put({ type: RECOOTHER_RECOMMEND_CONTENTS_SUCCESS, payload: {} });
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RECO_RECOMMEND_CONTENTS_66, {
      params: { pageType: param.pageType || 'soft', time: +new Date() },
    });
    if (res.data.status === 0) {
      let type = '';
      if (param.pageType === 'soft') {
        type = RECO_RECOMMEND_CONTENTS_SUCCESS;
      } else if (param.pageType === 'upgrade') {
        type = RECOOTHER_RECOMMEND_CONTENTS_SUCCESS;
      } else if (param.pageType === 'work') {
        type = RECOWORK_RECOMMEND_CONTENTS_SUCCESS;
      }
      if (type) {
        yield put({ type, payload: { ...res.data, ...param } });
      }
    }
  } catch (error) {
    // throw error;
  }
}
/**
 * 首页改版后获取banner 2021-1-19 21:43:00
 */
function* fetchRecoBanner(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RECO_TOP_CONTENTS_66, {
      params: { pageType: param.pageType || 'soft', time: +new Date() },
    });
    if (res.data.status === 0) {
      let type = '';
      if (param.pageType === 'soft') {
        type = RECO_TOP_CONTENTS_SUCCESS;
      } else if (param.pageType === 'upgrade') {
        type = RECOOTHER_TOP_CONTENTS_SUCCESS;
      } else if (param.pageType === 'work') {
        type = RECOWORK_TOP_CONTENTS_SUCCESS;
      }
      if (type) {
        yield put({ type, payload: { ...res.data, ...param } });
      }
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 频道banners
 */
function* fetchBannerContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(BANNER_CONTENT_61, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECOMMEND_BANNER_SUCCESS,
        payload: {
          ...res.data.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 流行榜
 */
function* fetchWeekHotContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RANK_MIX_RANK_53, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECOMMEND_WEEK_HOTS_SUCCESS,
        payload: {
          ...res.data.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 精品推荐
 */
function* fetchRecommendContent(param) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(RECOMMEND_CONTENT_53, {
      params: { pageType: param.pageType || 'soft' },
    });
    if (res.data.status === 0) {
      yield put({
        type: RECOMMEND_RECOMMEND_SUCCESS,
        payload: {
          ...res.data.data,
          ...param,
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 猜你喜欢
 */
function* fetchGuessLike({ skip = 0, limit = 30 }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GUESS_LIKES_NEW_61, { params: { skip, limit } });
    if (res.data.status === 0) {
      let apps = [];
      if (res.data.data && res.data.data.apps && res.data.data.apps.length > 0) {
        apps = res.data.data.apps;
      }
      yield put({
        type: GUESS_LIKES_SUCCESS,
        payload: { ...res.data.data, apps, skip, limit, loading: false },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 批量获取应用详情
 */
function* fetchSoftInfos({ softIds = [], pns = [], bizInfo = {} }) {
  try {
    const axios = yield createAxios();
    const res = yield axios.post(GET_SOFT_INFOS_55, { softIds, pns, bizInfo });
    if (res.data.status === 0) {
      yield put({
        type: GET_SOFTINFOS_SUCCESS,
        payload: { ...res.data, loading: false, softIds, pns },
      });
    }
  } catch (error) {
    // throw error;
  }
}

/**
 * 批量获取应用详情，根据版本号（8.3先不支持版本号，使用老接口）
 */
function* fetchSoftInfosByVersion({ commandLine, sessionId = '' }) {
  try {
    // 支持下载多个软件，并且支持下载每个软件的指定版本（PC，安卓都支持）
    const bizId = getParamString('bizId', commandLine);
    const bizType = getParamString('bizType', commandLine);
    let softs = [];
    const softIds = [];
    const pns = [];
    const bizInfo = { bizId, bizType };

    if (window.atob) {
      try {
        const softsJSONStr = window.atob(getParamString('softs', commandLine) || '');
        softs = JSON.parse(softsJSONStr);
      } catch (err) {
        logNative(
          `命令行：调起商店 install_by_version, 解析失败 ${getParamString('softs', commandLine)}`,
        );
      }
    }

    for (let i = 0; i < softs.length; i++) {
      if (softs[i].SoftID || softs[i].softID) {
        softIds.push(softs[i].SoftID || softs[i].softID);
      }
      if (softs[i].PackageName || softs[i].packageName || softs[i].Pn || softs[i].pn) {
        pns.push(softs[i].PackageName || softs[i].packageName || softs[i].Pn || softs[i].pn);
      }
    }

    const axios = yield createAxios();
    const res = yield axios.post(GET_SOFT_INFOS_55, { softIds, pns, bizInfo });
    if (res.data.status === 0) {
      yield put({
        type: GET_SOFTINFOS_BY_V_SUCCESS,
        payload: { ...res.data, loading: false, softIds, pns, sessionId },
      });
    }
  } catch (error) {
    // throw error;
  }
}

export function* watchFetchRecoBanner() {
  yield takeLatest(RECO_TOP_CONTENTS_REQUEST, fetchRecoBanner);
}
export function* watchFetchRecoRecommend() {
  yield takeLatest(RECO_RECOMMEND_CONTENTS_REQUEST, fetchRecoRecommend);
}

export function* watchFetchRecoOtherTop() {
  yield takeLatest(RECOMMEND_OTHER_TOP_REQUEST, fetchRecoOtherTop);
}
export function* watchBannerContent() {
  yield takeLatest(RECOMMEND_BANNER_REQUEST, fetchBannerContent);
}
export function* watchWeekHotContent() {
  yield takeLatest(RECOMMEND_WEEK_HOTS_REQUEST, fetchWeekHotContent);
}
export function* watchRecommendContent() {
  yield takeLatest(RECOMMEND_RECOMMEND_REQUEST, fetchRecommendContent);
}
export function* watchGroupContent() {
  yield takeLatest(RECOMMEND_GROUP_REQUEST, fetchGroupContent);
}
export function* watchGuessLike() {
  yield takeLatest(GUESS_LIKES_REQUEST, fetchGuessLike);
}
export function* watchSoftInfos() {
  yield takeLatest(GET_SOFTINFOS_REQUEST, fetchSoftInfos);
}

export function* watchSoftInfosByVersion() {
  yield takeLatest(GET_SOFTINFOS_BY_V_REQUEST, fetchSoftInfosByVersion);
}
